module.exports = fox._r("images/blank.gif", __webpack_public_path__ + "images/blank.gif");


//////////////////
// WEBPACK FOOTER
// ./images/blank.gif
// module id = 1021
// module chunks = 4